import { render, staticRenderFns } from "./UserCreditListView.vue?vue&type=template&id=fb8883aa&scoped=true"
import script from "./UserCreditListView.vue?vue&type=script&lang=js"
export * from "./UserCreditListView.vue?vue&type=script&lang=js"
import style0 from "./UserCreditListView.vue?vue&type=style&index=0&id=fb8883aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8883aa",
  null
  
)

export default component.exports